import EditAiModel from "./EditAiModel";

export default EditAiModel;